module.exports = __webpack_public_path__ + "img/top_inside_left.8f038628.svg";